<span [innerHTML]="shownMemoValue$ | highlightText$: searchValue | async"> </span>
